/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import PACross from "component/react-bootstrap/pa-icons/PACross";
import { useTranslation } from "next-i18next";
import HideIf from "util/HideIf";
import styles from "./searchModal.module.scss";

export default function SearchModal(props) {
  const {
    searchMainDivRef, value, onKeyDown, changeText,
    searchBarRef, setValue,
  } = props;

  const { t } = useTranslation("common");

  function crossIconHandler() {
    setValue("");
    searchBarRef.current.innerHTML = "";
  }

  return (

    <>
      <div
        className={`${styles.main_div} ${styles.auto_suggest_container}`}
        ref={searchMainDivRef}
      >
        <span className="" style={{ width: "100%", whiteSpace: "nowrap" }}>
          <input
            type="text"
            id="search-input"
            className={`m-0 m-r-5 ${styles.search_input} ${styles.inputContenteditable}`}
            onKeyDown={onKeyDown}
            onInput={changeText}
            value={value}
            ref={searchBarRef}
            placeholder={t("search.placeholder")}
            maxLength={200}
          />
        </span>
        <HideIf show={value}>
          <PACross thinCross className={styles.cross} onClick={crossIconHandler} />
        </HideIf>

      </div>

    </>

  );
}
